export const CxfEvents = {
    Token: 'cxf.token',
    Login: 'cxf.login',
    Signup: 'cxf.signup',
    GameEventUpdate: 'cxf.gameEvent.update',
    GameEventAdd: 'cxf.gameEvent.add',
    GameEventRemove: 'cxf.gameEvent.remove',
    XpChanged: 'cxf.xp.changed',
    LevelChanged: 'cxf.level.changed',
    LegendLevelChanged: 'cxf.legendLevel.changed',
    Push: 'cxf.push',
    OpenIGS: 'cxf.igs.open'
}

export const BigFarm = {
    UPDATE_PAY: 'PAYMENT_DATA'
}

export const Empire = {
    UPDATE_PAY: 'upi'
}

export const HTML_IDS = {
    AD_PLACEHOLDER: `ad-placeholder`,
    AD_CONTAINER: `ad-container`
}

export const AdBannerEvent = {
    LOGIN: 'login',
    UPDATE_PAY: 'updatePay'
}
